import { Grid } from '@mui/material';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import React, { useCallback, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import cookies from 'common/utils/cookies';

import { useTranslation } from '../../../../packages/common/utils/getLocalString';
import LoginForm from '../LoginForm/LoginForm';
import { signInWithLoginOrEmail } from '../actions';

// Original class: LeftContainerRoot
const StyledLeftContainerRoot = styled(Grid)(({ theme }) => ({
  height: '100%',
  backgroundColor: '#ffffff',
  borderRadius: theme.spacing(4),

  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
    padding: theme.spacing(0, 5),
  },
}));

const LeftContainer = () => {
  const getLocalString = useTranslation();
  const dispatch = useDispatch();
  const [isSaveData, setUserSaveData] = useState(false);

  const { current: handleChangeDataSave } = useRef(() => {
    setUserSaveData(prevState => !prevState);
  });

  const formatAuthError = useCallback(
    err => {
      switch (err) {
        case 'Unauthorized': {
          return getLocalString('AuthContainer', 'errors', 'login');
        }
        default:
          return getLocalString('AuthContainer', 'errors', 'error');
      }
    },
    [getLocalString],
  );

  const handleSignIn = useCallback(
    async ({ username, password, setErrors }) => {
      const { payload: userResponse } = await dispatch(
        signInWithLoginOrEmail({ username, password }),
      );
      if (userResponse.error) {
        return setErrors({
          username: formatAuthError(userResponse.error),
          password: formatAuthError(userResponse.error),
          requestAnswer: formatAuthError(userResponse.error),
        });
      }
      // return cookies.setCookie({
      //   key: 'access_token',
      //   value: userResponse.access_token,
      //   host: `${window.location.protocol}//${window.location.hostname}`,
      // });
    },
    [dispatch, formatAuthError],
  );

  return (
    <StyledLeftContainerRoot
      size='grow'
      container
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <LoginForm
        isSaveData={isSaveData}
        setUserSaveData={setUserSaveData}
        handleChangeDataSave={handleChangeDataSave}
        handleSignIn={handleSignIn}
      />
    </StyledLeftContainerRoot>
  );
};

export default LeftContainer;
